import { render } from "./IndexPage.vue?vue&type=template&id=437c9342&scoped=true"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"

import "./IndexPage.vue?vue&type=style&index=0&id=437c9342&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437c9342"]])

export default __exports__